export const profileModerationStatus = {
  new: 'new',
  active: 'active',
  rejected: 'rejected',
}

export const virtualModerationStatus = {
  incomplete: 'Incomplete',
  moderation: 'Moderation',
  rejected: 'Rejected',
  active: 'Active',
}
